import { LengthValidatorConfig, ValdrValidator } from '@app/valdr/models';
import { stringLengthValidator } from '@app/valdr/validators/length-validator';
import * as R from 'ramda';

export const maxLengthValidator: ValdrValidator = R.curry(({number: maxLength}: LengthValidatorConfig, value: any) =>
  stringLengthValidator(R.gte(maxLength), value)
);
